import { z } from 'zod';

/** Batch limits of technical §11.3: above either one, the API answers 413. */
export const INGESTION_MAX_EVENTS = 500;
export const INGESTION_MAX_BYTES = 512 * 1024;

/**
 * Acknowledgement of a batch (technical §11.3 step 8). Counters only: an
 * ingestion response never carries event content.
 */
export const ingestionReceiptDto = z
  .object({
    acceptedCount: z.number().int().min(0),
    duplicateCount: z.number().int().min(0),
    /** Events refused by the second redaction net, or every event while the project is suspended. */
    rejectedCount: z.number().int().min(0),
  })
  .strict();
export type IngestionReceipt = z.infer<typeof ingestionReceiptDto>;
